function n(n, r, t) {
  return {
    r: 255 * t(n.r / 255, r.r / 255),
    g: 255 * t(n.g / 255, r.g / 255),
    b: 255 * t(n.b / 255, r.b / 255)
  };
}

function r(n, r) {
  return r;
}

function t(n, r) {
  return n * r;
}

function u(n, r) {
  return n + r - n * r;
}

function o(n, r) {
  return f(r, n);
}

function i(n, r) {
  return Math.min(n, r);
}

function a(n, r) {
  return Math.min(Math.max(n, r), 1);
}

function e(n, r) {
  return 0 === n ? 0 : 1 === r ? 1 : Math.min(1, n / (1 - r));
}

function c(n, r) {
  return 1 === n ? 1 : 0 === r ? 0 : 1 - Math.min(1, (1 - n) / r);
}

function f(n, r) {
  return r <= .5 ? t(n, 2 * r) : u(n, 2 * r - 1);
}

function g(n, r) {
  return r <= .5 ? n - (1 - 2 * r) * n * (1 - n) : n + (2 * r - 1) * ((n <= .25 ? ((16 * n - 12) * n + 4) * n : Math.sqrt(n)) - n);
}

function b(n, r) {
  return Math.abs(n - r);
}

function s(n, r) {
  return n + r - 2 * n * r;
}

function h(n, r, t) {
  return Math.min(Math.max(n, r), t);
}

function M(n) {
  return {
    r: h(n.r, 0, 255),
    g: h(n.g, 0, 255),
    b: h(n.b, 0, 255),
    a: h(n.a, 0, 1)
  };
}

function m(n) {
  return {
    r: 255 * n.r,
    g: 255 * n.g,
    b: 255 * n.b,
    a: n.a
  };
}

function d(n) {
  return {
    r: n.r / 255,
    g: n.g / 255,
    b: n.b / 255,
    a: n.a
  };
}

function l(n, r) {
  void 0 === r && (r = 0);
  var t = Math.pow(10, r);
  return {
    r: Math.round(n.r * t) / t,
    g: Math.round(n.g * t) / t,
    b: Math.round(n.b * t) / t,
    a: n.a
  };
}

function p(n, r, t, u, o, i) {
  return (1 - r / t) * u + r / t * Math.round((1 - n) * o + n * i);
}

function v(n, r, t, u, o) {
  void 0 === o && (o = {
    unitInput: !1,
    unitOutput: !1,
    roundOutput: !0
  }), o.unitInput && (n = m(n), r = m(r)), n = M(n);
  var i = (r = M(r)).a + n.a - r.a * n.a,
      a = t(n, r, u),
      e = M({
    r: p(n.a, r.a, i, n.r, r.r, a.r),
    g: p(n.a, r.a, i, n.g, r.g, a.g),
    b: p(n.a, r.a, i, n.b, r.b, a.b),
    a: i
  });
  return o.unitOutput ? d(e) : o.roundOutput ? l(e) : function (n) {
    return l(n, 9);
  }(e);
}

function x(n, r, t) {
  return m(t(d(n), d(r)));
}

function O(n) {
  return .3 * n.r + .59 * n.g + .11 * n.b;
}

function y(n, r) {
  var t = r - O(n);
  return function (n) {
    var r = O(n),
        t = n.r,
        u = n.g,
        o = n.b,
        i = Math.min(t, u, o),
        a = Math.max(t, u, o);

    function e(n) {
      return r + (n - r) * r / (r - i);
    }

    function c(n) {
      return r + (n - r) * (1 - r) / (a - r);
    }

    return i < 0 && (t = e(t), u = e(u), o = e(o)), a > 1 && (t = c(t), u = c(u), o = c(o)), {
      r: t,
      g: u,
      b: o
    };
  }({
    r: n.r + t,
    g: n.g + t,
    b: n.b + t
  });
}

function I(n) {
  return Math.max(n.r, n.g, n.b) - Math.min(n.r, n.g, n.b);
}

function L(n, r) {
  var t = ["r", "g", "b"].sort(function (r, t) {
    return n[r] - n[t];
  }),
      u = t[0],
      o = t[1],
      i = t[2],
      a = {
    r: n.r,
    g: n.g,
    b: n.b
  };
  return a[i] > a[u] ? (a[o] = (a[o] - a[u]) * r / (a[i] - a[u]), a[i] = r) : a[o] = a[i] = 0, a[u] = 0, a;
}

function k(n, r) {
  return y(L(r, I(n)), O(n));
}

function q(n, r) {
  return y(L(n, I(r)), O(n));
}

function w(n, r) {
  return y(r, O(n));
}

function B(n, r) {
  return y(n, O(r));
}

function D(t, u) {
  return v(t, u, n, r);
}

function j(r, u) {
  return v(r, u, n, t);
}

function z(r, t) {
  return v(r, t, n, u);
}

function A(r, t) {
  return v(r, t, n, o);
}

function C(r, t) {
  return v(r, t, n, i);
}

function E(r, t) {
  return v(r, t, n, a);
}

function F(r, t) {
  return v(r, t, n, e);
}

function G(r, t) {
  return v(r, t, n, c);
}

function H(r, t) {
  return v(r, t, n, f);
}

function J(r, t) {
  return v(r, t, n, g);
}

function K(r, t) {
  return v(r, t, n, b);
}

function N(r, t) {
  return v(r, t, n, s);
}

function P(n, r) {
  return v(n, r, x, k);
}

function Q(n, r) {
  return v(n, r, x, q);
}

function R(n, r) {
  return v(n, r, x, w);
}

function S(n, r) {
  return v(n, r, x, B);
}

export { R as color, G as colorBurn, F as colorDodge, C as darken, K as difference, N as exclusion, H as hardLight, P as hue, E as lighten, S as luminosity, j as multiply, D as normal, A as overlay, Q as saturation, z as screen, J as softLight };